import { render } from "./Nearby.vue?vue&type=template&id=1b08c2ed&scoped=true&bindings={\"nearbyList\":\"setup\"}"
import script from "./Nearby.vue?vue&type=script&lang=js"
export * from "./Nearby.vue?vue&type=script&lang=js"

import "./Nearby.vue?vue&type=style&index=0&id=1b08c2ed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b08c2ed"

export default script